const googlePaySelector = store => store.googlePay;

export default googlePaySelector;
